import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { Login } from '../screens/login/_Login'
import { SelectAccount } from '../screens/login/_SelectUser'
import { useGlobalContext } from '../context/ContextGlobal'
import { LoginLayout } from '../screens/_layouts/login/loginLayout'
import { AdminLayout } from '../screens/_layouts/administration/adminLayoutNavBar'
import { AHome } from '../screens/administration/home'
import { Esquecisenha } from '../screens/login/_EsqueciSenha'
import { FirstAccess } from '../screens/login/_PrimeiroAcesso'
import { AdminSettingsLayout } from '../screens/_layouts/administration/settingsLayout'
import { AdminSectors } from '../screens/administration/settings/sector'
import { AdminAddSectors } from '../screens/administration/settings/sector/_AddSector'
import { AdminAddUsers, AdminEditUsers, AdminUsers } from '../screens/administration/settings/users'
import { AdminEditSectors } from '../screens/administration/settings/sector/_EditSector'
import { APlans } from '../screens/administration/settings/plans'
import { AAddPlans } from '../screens/administration/settings/plans/_AddPlans'
import { AEditPlans } from '../screens/administration/settings/plans/_EditPlans'
import { AdminDocuments, AdminAddDocuments, AdminEditDocuments } from '../screens/administration/settings/documents'
import { AdminConsents, AdminAddConsents, AdminEditConsents } from '../screens/administration/settings/consents'
import { AInformationEnterprise } from '../screens/administration/settings/information'
import { AdminPositions, AdminAddPositions, AdminEditPositions } from '../screens/administration/settings/positions'
import { AClients } from '../screens/administration/clients'
import { AAddClients } from '../screens/administration/clients/_AddClients'
import { Path } from './paths'
import { AEditClients } from '../screens/administration/clients/_EditClients'
import { NotFound } from '../components/layouts/errors/notFound'
import { Protections } from '../components/layouts/protections'
import { AdminCollaborators } from '../screens/administration/collaborators'
import { AddAdminCollaborators } from '../screens/administration/collaborators/_AddCollaborators'
import { EditAdminCollaborator } from '../screens/administration/collaborators/_EditCollaborator'
import { CollaboratorEditSidebar } from '../screens/administration/collaborators/_components/collaboratorEditSidebar'
import { AdminCollaboratorPositions } from '../screens/administration/collaborators/_CollaboratorPositions'
import { AdminCollaboratorPayments } from '../screens/administration/collaborators/_CollaboratorPayments'
import { AdminCollaboratorCandidacys } from '../screens/administration/collaborators/_CollaboratorCandidacys'
import { AdminCollaboratorBlocked } from '../screens/administration/collaborators/_CollaboratorBlocked'
import { AdminCollaboratorFavorite } from '../screens/administration/collaborators/_CollaboratorFavorite'
import { ClientLayoutNavBar } from '../screens/_layouts/clients/clientLayoutNavBar'
import { ClientLayoutSideBarSettings } from '../screens/_layouts/clients/clientLayoutSideBarSettings'
import { ClientHome } from '../screens/client/home/home/home'
import { ClientInfoEnterprise } from '../screens/client/settings/InfoEnterprise'
import { ClientUsers, ClientAddUsers, ClientEditUsers } from '../screens/client/settings/users'
import { ClientAddSectors, ClientEditSectors, ClientSectors } from '../screens/client/settings/sectors'
import { ClientPayments } from '../screens/client/settings/payments'
import { ClientInformations } from '../screens/client/settings/Informations'
import {
  ClientEvents,
  ClientAddEvents,
  ClientEditEvents,
  ClientEventsFinally,
  ClientEventsHistory,
  ClientEventsStaff,
  ClientEventsjobOffers,
  ClientLayoutSideBarEvents,
  ClientEventsMessages,
} from '../screens/client/events'
// import { ClientTeams } from '../screens/client/teams/clientTeams'
// import { ClientAddTeams } from '../screens/client/teams/clientAddTeams'
// import { ClientEditTeams } from '../screens/client/teams/clientEditTeams'
import ScrollToTop from './scrollToTop'
import { ClientCitys } from '../screens/client/settings/citys'
import { ClientFavorites } from '../screens/client/favorites'
import { ClientBlockeds } from '../screens/client/blockeds/clientBlockeds'
import { ClientLayoutSideBarClient } from '../screens/administration/clients/_sideBar/clientSideBarClientLayout'
import { AdminClientsBilling } from '../screens/administration/clients/_BillingClients'
import { AdminClientsPayments } from '../screens/administration/clients/_PaymentsClients'
import { AdminLogSystem } from '../screens/administration/settings/logSystem'
import { AdminReasons } from '../screens/administration/settings/reasons'
import { AdminReports } from '../screens/administration/settings/reports/AdminReports'
import { AdminAddReports } from '../screens/administration/settings/reports/_AddReports'
import { AdminEditReports } from '../screens/administration/settings/reports/_EditReports'
import { AdminAddNotices, AdminEditNotices, AdminNotices } from '../screens/administration/settings/notices'
import { CollabHome } from '../screens/collaborator/account'
import { CollabNotAutorization } from '../screens/collaborator/notAutorization'
import { CollaboratorPlans } from '../screens/collaborator/account/CollaboratorPlans'
import { CollaboratorHistory } from '../screens/collaborator/account/CollaboratorHistory'
import { CollaboratorSelectionHistory } from '../screens/collaborator/account/CollaboratorHistory/historySelected'
import { CollabSignUp } from '../screens/collaborator/register'
import { CollaboratorSelectPlans } from '../screens/collaborator/register/SelectPlan'
import { CollaboratorSelectedPlan } from '../screens/collaborator/register/SelectPlan/SelectedPlan'
import { CollaboratorRegisterFinally } from '../screens/collaborator/register/finally'
import CollaboratorLogin from '../screens/collaborator/login'
import PrivacyPolicy from '../screens/collaborator/privacy'
import { CollabSignPlanSelected } from '../screens/collaborator/account/CollaboratorSignPlan/planSelected'
import { CollaboratorSignPlan } from '../screens/collaborator/account/CollaboratorSignPlan'
import SupportCollab from '../screens/collaborator/support'
import EmailVerification from '../screens/collaborator/emailVerification'
import { CollaboratorRegisterPayment } from '../screens/collaborator/account/CollaboratorSignPlan/signPlanRecurrence'
import { CollaboratorRegisterPaymentResume } from '../screens/collaborator/account/CollaboratorSignPlan/signPlanRecurrence/resume'
import DeleteAccount from '../screens/collaborator/deleteAcc'
import { ConfirmDelete } from '../screens/collaborator/deleteAcc/confirmDelete'
import { AdminClientAddUsers } from '../screens/administration/clients/_ClientAddUsers'
import { ClientEventReports } from '../screens/client/events/clientEventsReports'
import { ClientCampaign } from '../screens/client/campaign/clientCampaign'

export const MainRouter = () => {
  const { user } = useGlobalContext()

  const userPermissions = user?.user?.permissions ?? {}

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* LOGIN */}
        <Route path={Path.Login} element={<LoginLayout />}>
          <Route path={Path.Login} element={<Login />} />
          <Route path={Path.PasswordRecovery} element={<Esquecisenha />} />
          <Route path={Path.FirstAccess(':email')} element={<FirstAccess />} />
          <Route
            path={Path.SelectAccount}
            element={
              <Protections.Global required={user} permission={true}>
                <SelectAccount />
              </Protections.Global>
            }
          />
        </Route>
        {/* ADMINISTRATION */}
        <Route path={Path.AdministrationHome} element={<AdminLayout />}>
          <Route
            path={Path.AdministrationHome}
            element={
              <Protections.Global required={user?.user?.type === 'admin'} permission={true}>
                <AHome />
              </Protections.Global>
            }
          />
          <Route
            path={Path.AClients}
            element={
              <Protections.Global
                required={user?.user?.type === 'admin'}
                permission={userPermissions?.clientes_vizualizar}
              >
                <AClients />
              </Protections.Global>
            }
          />
          <Route
            path={Path.AAdicionarClientes}
            element={
              <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.clientes_criar}>
                <AAddClients />
              </Protections.Global>
            }
          />
          <Route
            path={Path.AdminClientEdit(':id')}
            element={
              <Protections.Global required={user?.user?.type === 'admin'} permission={true}>
                <ClientLayoutSideBarClient />
              </Protections.Global>
            }
          >
            <Route
              path={Path.AdminClientEdit(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.clientes_editar}
                >
                  <AEditClients />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminClientBilling(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.clientes_editar}
                >
                  <AdminClientsBilling />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminClientPayments(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.clientes_editar}
                >
                  <AdminClientsPayments />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminClientAddUser(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.clientes_editar}
                >
                  <AdminClientAddUsers />
                </Protections.Global>
              }
            />
          </Route>

          {/* Contributor */}

          <Route
            path={Path.AdminCollaborators}
            element={
              <Protections.Global
                required={user?.user?.type === 'admin'}
                permission={userPermissions?.colaboradores_vizualizar || userPermissions?.colaboradores_visualizar}
              >
                <AdminCollaborators />
              </Protections.Global>
            }
          />
          <Route
            path={Path.AddAdminCollaborators}
            element={
              <Protections.Global
                required={user?.user?.type === 'admin'}
                permission={userPermissions?.colaboradores_criar}
              >
                <AddAdminCollaborators />
              </Protections.Global>
            }
          />
          <Route
            path={Path.EditAdminCollaborator(':id')}
            element={
              <Protections.Global required={user?.user?.type === 'admin'} permission={true}>
                <CollaboratorEditSidebar />
              </Protections.Global>
            }
          >
            <Route
              path={Path.EditAdminCollaborator(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_editar}
                >
                  <EditAdminCollaborator />
                </Protections.Global>
              }
            />
            <Route
              path={Path.EditAdminCollaboratorPositions(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_cargos}
                >
                  <AdminCollaboratorPositions />
                </Protections.Global>
              }
            />
            <Route
              path={Path.EditAdminCollaboratorFinancyOrPlans(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_financeiro}
                >
                  <AdminCollaboratorPayments />
                </Protections.Global>
              }
            />
            <Route
              path={Path.EditAdminCollaboratorCandidateEvents(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_candidatados}
                >
                  <AdminCollaboratorCandidacys />
                </Protections.Global>
              }
            />
            <Route
              path={Path.EditAdminCollaboratorBlockedCompanies(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_bloqueados}
                >
                  <AdminCollaboratorBlocked />
                </Protections.Global>
              }
            />
            <Route
              path={Path.EditAdminCollaboratorFavoriteCompanies(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.colaboradores_favoritos}
                >
                  <AdminCollaboratorFavorite />
                </Protections.Global>
              }
            />
          </Route>

          {/* SETTINGS */}
          <Route path={Path.ASettings} element={<AdminSettingsLayout />}>
            <Route path={Path.ASettings} element={<AInformationEnterprise />} />
            {/* CARGOS */}
            <Route
              path={Path.AdminCargos}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.cargos_vizualizar}
                >
                  <AdminPositions />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AAddCargos}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.cargos_criar}>
                  <AdminAddPositions />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditCargos(':id')}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.cargos_editar}>
                  <AdminEditPositions />
                </Protections.Global>
              }
            />
            {/* NOTICES */}
            <Route
              path={Path.AdminNotices}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.notices_vizualizar}
                >
                  <AdminNotices />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddNotices}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.notices_criar}>
                  <AdminAddNotices />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditNotices(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.notices_editar}
                >
                  <AdminEditNotices />
                </Protections.Global>
              }
            />
            {/* DOCUMENTS */}
            <Route
              path={Path.AdminDocuments}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.documentos_vizualizar}
                >
                  <AdminDocuments />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddDocuments}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.documentos_criar}
                >
                  <AdminAddDocuments />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditDocuments(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.documentos_editar}
                >
                  <AdminEditDocuments />
                </Protections.Global>
              }
            />
            {/* CONSENTS */}
            <Route
              path={Path.AdminConsents}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.consentimentos_vizualizar}
                >
                  <AdminConsents />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddConsents}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.consentimentos_criar}
                >
                  <AdminAddConsents />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditConsents(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.consentimentos_editar}
                >
                  <AdminEditConsents />
                </Protections.Global>
              }
            />
            {/* PLANS */}
            <Route
              path={Path.AdminPlans}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.planos_vizualizar}
                >
                  <APlans />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddPlans}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.planos_criar}>
                  <AAddPlans />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AEditPlans(':id')}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.planos_editar}>
                  <AEditPlans />
                </Protections.Global>
              }
            />
            {/* SECTOR */}
            <Route
              path={Path.AdminSectors}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.setores_vizualizar}
                >
                  <AdminSectors />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddScetors}
              element={
                <Protections.Global required={user?.user?.type === 'admin'} permission={userPermissions?.setores_criar}>
                  <AdminAddSectors />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditSectors(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.setores_editar}
                >
                  <AdminEditSectors />
                </Protections.Global>
              }
            />
            {/* USERS */}
            <Route
              path={Path.AdminUsers}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.usuarios_vizualizar}
                >
                  <AdminUsers />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AAddUsers}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.usuarios_criar}
                >
                  <AdminAddUsers />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AEditUsers(':uid')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.usuarios_editar}
                >
                  <AdminEditUsers />
                </Protections.Global>
              }
            />
            {/* Reports */}
            <Route
              path={Path.AdminReports}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.relatorios_vizualizar}
                >
                  <AdminReports />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminAddReports}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.relatorios_criar}
                >
                  <AdminAddReports />
                </Protections.Global>
              }
            />
            <Route
              path={Path.AdminEditReports(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.relatorios_editar}
                >
                  <AdminEditReports />
                </Protections.Global>
              }
            />

            {/* REASONS */}
            <Route
              path={Path.AdminReasons}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.motivos_visualizar}
                >
                  <AdminReasons />
                </Protections.Global>
              }
            />

            {/* LOG SYSTEM */}
            <Route
              path={Path.AdminLogSystem}
              element={
                <Protections.Global
                  required={user?.user?.type === 'admin'}
                  permission={userPermissions?.logsystem_visualizar}
                >
                  <AdminLogSystem />
                </Protections.Global>
              }
            />
          </Route>
        </Route>

        <Route path={Path.ClientHome} element={<ClientLayoutNavBar />}>
          <Route
            path={Path.ClientHome}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={true}
                status={user?.client?.status}
              >
                <ClientHome />
              </Protections.Global>
            }
          />
          <Route path={Path.ClientSettings} element={<ClientLayoutSideBarSettings />}>
            <Route
              path={Path.ClientSettings}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.configurations_viewinfos}
                >
                  <ClientInfoEnterprise />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientUsers}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.users_view}>
                  <ClientUsers />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientAddUsers}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.users_add}>
                  <ClientAddUsers />
                </Protections.Global>
              }
            />

            <Route
              path={Path.ClientEditUsers(':uid')}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.users_edit}>
                  <ClientEditUsers />
                </Protections.Global>
              }
            />

            <Route
              path={Path.ClientSectors}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.sectors_view}>
                  <ClientSectors />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientAddSectors}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.sectors_add}>
                  <ClientAddSectors />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientEditSectors(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.sectors_update}
                >
                  <ClientEditSectors />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientPayments}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.payments_view}
                >
                  <ClientPayments />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientInformations}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={true}>
                  <ClientInformations />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientCitys}
              element={
                <Protections.Global required={user?.user?.type === 'client'} permission={userPermissions?.city_view}>
                  <ClientCitys />
                </Protections.Global>
              }
            />
          </Route>
          <Route
            path={Path.ClientCampaigns}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.events_view}
                status={user?.client?.status}
              >
                <ClientCampaign />
              </Protections.Global>
            }
          />
          <Route
            path={Path.ClientEvents}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.events_view}
                status={user?.client?.status}
              >
                <ClientEvents />
              </Protections.Global>
            }
          />
          <Route
            path={Path.ClientAddEvents}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.events_add}
                status={user?.client?.status}
              >
                <ClientAddEvents />
              </Protections.Global>
            }
          />
          <Route
            path={Path.ClientEditEvents(':id')}
            element={
              <Protections.Global required={user?.user?.type === 'client'} permission={true}>
                <ClientLayoutSideBarEvents />
              </Protections.Global>
            }
          >
            <Route
              path={Path.ClientEditEvents(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.events_edit}
                  status={user?.client?.status}
                >
                  <ClientEditEvents />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientjobOffersEvents(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.jobOffers_view}
                  status={user?.client?.status}
                >
                  <ClientEventsjobOffers />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientStaffEvents(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.staffEvent_view}
                  status={user?.client?.status}
                >
                  <ClientEventsStaff />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientHistoryEvent(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.historyEvent_view}
                  status={user?.client?.status}
                >
                  <ClientEventsHistory />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientStaffFinally(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.finallyEvent_view}
                  status={user?.client?.status}
                >
                  <ClientEventsFinally />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientEventsMessage(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.messagesEvents_view}
                  status={user?.client?.status}
                >
                  <ClientEventsMessages />
                </Protections.Global>
              }
            />
            <Route
              path={Path.ClientEventsReports(':id')}
              element={
                <Protections.Global
                  required={user?.user?.type === 'client'}
                  permission={userPermissions?.messagesEvents_view}
                  status={user?.client?.status}
                >
                  <ClientEventReports />
                </Protections.Global>
              }
            />
          </Route>
          {/* <Route
            path={Path.ClientTeams}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.teams_view}
                status={user?.client?.status}
              >
                <ClientTeams />
              </Protections.Global>
            }
          /> */}
          {/* <Route
            path={Path.ClientAddTeams}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.teams_add}
                status={user?.client?.status}
              >
                <ClientAddTeams />
              </Protections.Global>
            }
          /> */}
          {/* <Route
            path={Path.ClientEditTeams(':id')}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.teams_edit}
                status={user?.client?.status}
              >
                <ClientEditTeams />
              </Protections.Global>
            }
          /> */}
          <Route
            path={Path.ClientFavorites}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.favorites_view}
                status={user?.client?.status}
              >
                <ClientFavorites />
              </Protections.Global>
            }
          />
          <Route
            path={Path.ClientBlockeds}
            element={
              <Protections.Global
                required={user?.user?.type === 'client'}
                permission={userPermissions?.blockeds_view}
                status={user?.client?.status}
              >
                <ClientBlockeds />
              </Protections.Global>
            }
          />
        </Route>

        {/* COLLABORATOR */}
        <Route path={Path.CollabLogin} element={<CollaboratorLogin />} />
        <Route path={Path.CollabSignUp} element={<CollabSignUp />} />
        <Route path={Path.CollabSelectPlans} element={<CollaboratorSelectPlans />} />
        <Route path={Path.CollabSelectedPlan(':planId')} element={<CollaboratorSelectedPlan />} />
        <Route path={Path.CollabSignUpFinally} element={<CollaboratorRegisterFinally />} />
        <Route path={Path.PrivacyPolicy} element={<PrivacyPolicy />} />
        <Route path={Path.DeleteAccount} element={<DeleteAccount />} />
        <Route path={Path.DeleteAccountConfirm(':token', ':uuid')} element={<ConfirmDelete />} />
        <Route path={Path.CollabHome(':token')} element={<CollabHome />} />
        <Route path={Path.CollabPlans(':token')} element={<CollaboratorPlans />} />
        <Route path={Path.CollabSignPlan(':token')} element={<CollaboratorSignPlan />} />
        <Route path={Path.CollabSignPlanSelected(':token', ':planId')} element={<CollabSignPlanSelected />} />
        <Route path={Path.CollabHistory(':token')} element={<CollaboratorHistory />} />
        <Route path={Path.CollabRegisterPayment(':token', ':planId')} element={<CollaboratorRegisterPayment />} />
        <Route
          path={Path.CollabRegisterPaymentResume(':token', ':planId')}
          element={<CollaboratorRegisterPaymentResume />}
        />
        <Route path={Path.CollabHistorySelected(':token', ':paymentId')} element={<CollaboratorSelectionHistory />} />
        <Route path={Path.CollabNotAutorization} element={<CollabNotAutorization />} />
        <Route path={Path.CollabSupport} element={<SupportCollab />} />
        <Route path={Path.emailVerify(':token')} element={<EmailVerification />} />

        {/* NOT FOUND (sempre na última posição) */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

// cada página será um objeto
// {
//     path:"/componentes",
//     element: <Teste_Componentes /> ,
//     errorElement: <error404 />
// },
